<template>
  <div class="layout">
    <headerCell :bgColor="bgColor" :fontColor="fontColor"></headerCell>
    <div class="wrap">
      <div class="banner">
        <img src="../../assets/img/team/banner.png" alt="">
        <div class="text-wrap">
          <p>团队介绍</p>
          <span>TEAM INTRODUCTION</span>
        </div>
      </div>
      <div class="team">
        <div class="list" v-for="(item,index) in list" :key="index">
          <img :src="item.pic" alt="">
          <div class="info">
            <div class="name">{{item.name}}</div>
            <div class="title">{{item.title}}</div>
            <div class="des" v-html="item.des"></div>
          </div>
        </div>
      </div>
    </div>
    <footerCell></footerCell>
  </div>
</template>

<script>
import headerCell from '../../components/header/index';
import footerCell from '../../components/footer/index';
export default{
  data(){
    return{
      bgColor:'rgba(255,255,255,1)',
      fontColor:'#000',
      list:[
        {
          name:'薛海涛',
          title:'副总、技术负责人',
          des:'2000年毕业于北京工业大学。在大数据、<br/>区块链、供应链金融架构等领域屡破难关',
          pic:require('../../assets/img/team/xue.png')
        },
        {
          name:'赵景涛',
          title:'副总经理',
          des:'北京大学经济学博士，曾供职于申港证券、<br />渤海信托，从事供应链、不动产方面的<br />融资',
          pic:require('../../assets/img/team/zhao.png')
        }
      ]
    }
  },
  components:{
    headerCell,
    footerCell
  },
}
</script>

<style lang="less" scoped>
.layout{
  width:100%;
  min-height: 100vh;
  background: #f7f7f7;
  overflow: hidden;
  .banner{
    width:100vw;
    position: relative;
    overflow:hidden;
    img{
      display: block;
      width:100%;
    }
    .text-wrap{
      position: absolute;
      width:100%;
      text-align: center;
      left:0;
      top:50%;
      margin-top:-72px;
      p{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 80px;
        line-height: 82px;
        letter-spacing: 0.3em;
        color: #FFFFFF;
      }
      span{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 32px;
        letter-spacing: 0.16em;
        color: #FFFFFF;
        display: inline-block;
        margin-top:30px;
      }
    }
  }
  .team{
    display: flex;
    justify-content: center;
    align-items: center;
    padding:106px 0 200px 0;
    .list{
      background: #E9E9E9;
      display:flex;
      .info{
        padding:44px 26px 0 34px;
      }
      .name{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        color: #000000;
        margin-bottom:10px;
      }
      .title{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin-bottom:19px;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #545454;
      }
      &:first-child{
        margin-right:30px;
      }
    }
  }
}
</style>